import { IoIosClose, IoIosCheckmark } from 'react-icons/io';
import { useTranslation } from 'react-i18next';
import IUserOverviewProps from './interfaces/IUserOverviewProps';
import Shape from '../../shape';
import UserEditFormService from '../../../../pages/users/components/user-edit-form/services/user-edit-form.service';

function Overview({ userData, userAccountType }: Readonly<IUserOverviewProps>) {
    const { t } = useTranslation();

    const overviewTitle = t('Resumo');
    const userDataSubtitle = t('DadosUsuarios');
    const systemsSubtitle = t('SistemasPermitidos');

    const renderCarrier = (carrierName?: string) => {
        if (carrierName) {
            return (
                <>
                    <h4>{t('Transportadora')}</h4>
                    <span>{carrierName}</span>
                </>
            );
        }
        return '';
    };

    return (
        <Shape>
            <h1 className="overview-title">{overviewTitle}</h1>

            <div className="container">
                <div className="user-info">
                    <h2>{userDataSubtitle}</h2>

                    <h4>{t('Nome')}</h4>
                    <span>{userData.name}</span>

                    <h4>{t('Email')}</h4>
                    <span>{userData.email}</span>

                    <h4>{t('TipoUsuario')}</h4>
                    <span>
                        {UserEditFormService.TranslateUserTypesLabel(
                            Number(userData.type),
                            userAccountType,
                        )}
                    </span>

                    <span>{renderCarrier(userData.userCarrier?.name)}</span>
                </div>

                <div className="systems-info" key={0}>
                    <h2 key={0}>{systemsSubtitle}</h2>

                    {userData.systems?.map(system => (
                        <div className="system-checked" key={system.id}>
                            {system.isChecked ? (
                                <IoIosCheckmark />
                            ) : (
                                <IoIosClose />
                            )}
                            <span>{system.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </Shape>
    );
}

export default Overview;
